<app-header class="app-ui__header tk-ui__header"> </app-header>
<app-breadcrumb></app-breadcrumb>
<!--<tk-navbar class="app-ui__navbar tk-ui__navbar"></tk-navbar>-->

<tk-content class="app-ui__content tk-ui__content">
  <ng-content></ng-content>
</tk-content>

<!-- Yandex.Metrika counter (счетчик подсчета посетителей) -->
<app-metrika-counter [numberCounter]="98459578"></app-metrika-counter>
<!-- /Yandex.Metrika counter -->
